var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioWaveIcon = function SvgAudioWaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 22.5H7.5V3H9zm-3-15H4.5V18H6zm-3 3H1.5V15H3zM18 3h-1.5v19.5H18zm-3 4.5h-1.5V18H15zm-3 3h-1.5V15H12zm9-3h-1.5V18H21zm3 3h-1.5V15H24z",
    clipRule: "evenodd"
  })));
};
export default SvgAudioWaveIcon;